import React, { Component } from 'react';
import { connect } from 'react-redux';
import Brokers from "../../components/Brokers/brokers";
import {
    brokersListPageShift,
    changeBrokersListPage,
    changeBrokersState,
    getBrokers, getBrokersSuccess,
    getBrokersSuggestions, sortBrokers
} from "../../actions/brokers";
import CustomCheckbox from "../../components/General/customCheckbox";
import _ from 'lodash';
import {updateBrokerById} from "../../actions/broker";
import {getBrokerFirmsWithAgents} from "../../actions/brokerFirms";

const getSuggestionValue = suggestion => suggestion.username;

const renderSuggestion = suggestion => (
    <div>
        {suggestion.username}
    </div>
);

class BrokersHOC extends Component {

    constructor(props) {
        super(props);
        let askServer;
    }

    componentDidMount(){
        let calcOffset =this.props.viewAmount*(this.props.page -1);
        this.askServer = setTimeout(() => {
            this.props.getBrokers( {
                orderAsc: this.props.sortOrder === 'ASC',
                orderBySolicitorName:  this.props.sortBy ===  'name',
                orderByUserName:  this.props.sortBy ===  'username',
                orderByLawsysId:  this.props.sortBy ===  'brokerFirmId',
                orderByLawsysName:  this.props.sortBy ===  'brokerFirmName',
                lawsysId:  this.props.filterByBroker,
                limit: this.props.viewAmount,
                search:  this.props.suggestionFieldValue,
                offset: calcOffset>0? calcOffset:0,
            });
        }, 0);

        this.props.getBrokerFirmsWithAgents();
    }

    componentWillReceiveProps(nextProps){
        clearTimeout(this.askServer);
        if(
            (this.props.viewAmount !== nextProps.viewAmount) ||
            (this.props.sortBy !== nextProps.sortBy) ||
            (this.props.sortOrder !== nextProps.sortOrder) ||
            (this.props.page !== nextProps.page) ||
            (this.props.suggestionFieldValue !== nextProps.suggestionFieldValue) ||
            (this.props.filterByBroker !== nextProps.filterByBroker)
        ){
            let calcOffset = nextProps.viewAmount*(nextProps.page -1);
            const parameters = {
                orderAsc: nextProps.sortOrder === 'ASC',
                orderBySolicitorName:  nextProps.sortBy ===  'name',
                orderByUserName:  nextProps.sortBy ===  'username',
                orderByLawsysId:  nextProps.sortBy ===  'brokerFirmId',
                orderByLawsysName:  nextProps.sortBy ===  'brokerFirmName',
                lawsysId:  nextProps.filterByBroker,
                search:  nextProps.suggestionFieldValue,
                limit: nextProps.viewAmount,
                offset: calcOffset>0? calcOffset:0,
            };
            if(this.props.suggestionFieldValue !== nextProps.suggestionFieldValue && nextProps.suggestionFieldValue!==''){
                parameters.offset = 0;
                parameters.limit = 5;
                this.askServer = setTimeout(() => {
                    this.props.getBrokersSuggestions(parameters)
                }, 50);
            } else {
                this.props.getBrokers(parameters);
            }

        }
    }

    //function that returns true if the row is checked
    _isRowChecked = (key) => {
        return this.props.selectedBrokers.hasOwnProperty(key);
    };

    //function that handles row select from the brokers table
    _handleRowSelect = (key, row) => {
        let currentSelectedRows = {...this.props.selectedBrokers};
        if(currentSelectedRows.hasOwnProperty(key)){
            delete currentSelectedRows[key];
            this.props.changeBrokersState(
                {
                    key: 'selectedBrokers',
                    value: currentSelectedRows
                });
            if(this.props.allBrokersSelected){
                this.props.changeBrokersState(
                    {
                        key: 'allBrokersSelected',
                        value: false
                    })
            }
        }
        else {
            this.props.changeBrokersState(
                {
                    key: 'selectedBrokers',
                    value: {
                        ...currentSelectedRows,
                        [key]: row
                    }
                })
        }
    };

    //function that handles all rows select
    _handleAllRowsSelect = (evt) => {
        if(evt.target.checked) {
            let s = {};
            _.forEach(this.props.brokers, (broker) => {
                s = {...s, [broker.id]: broker}
            });
            this.props.changeBrokersState(
                {
                    key: 'selectedBrokers',
                    value: s
                });
        }
        else {
            this.props.changeBrokersState(
                {
                    key: 'selectedBrokers',
                    value: {}
                })
        }
        this.props.changeBrokersState(
            {
                key: 'allBrokersSelected',
                value: evt.target.checked
            })
    };

    applyAction = () => {
        if(!this.props.action || !_.size(this.props.selectedBrokers)){return false;}
        _.forEach(this.props.selectedBrokers, selectedBroker => {
            this.props.updateBrokerById({
                sendBody: {
                    userId: selectedBroker.userId,
                    status: this.props.action === 'enable'
                }
            })
        })

    };

    onSuggestionChange = (event, { newValue }) => {
        this.props.changeBrokersState({
            key: 'suggestionFieldValue',
            value: newValue
        });
    };

    onSuggestionsFetchRequested = ({ value }) => {
        //this.props.getBrokersSuggestions()
        this.props.changeBrokersState({
            key: 'suggestions',
            value: this.getSuggestions()
        });
    };

    getSuggestions = value => {
        return this.props.suggestions
    };

    onSuggestionsClearRequested = () => {
        this.props.changeBrokersState({
            key: 'suggestions',
            value: []
        });
    };

    onSuggestionSelected = (event, { suggestion, suggestionValue, suggestionIndex, sectionIndex, method }) => {
        this.props.changeBrokersState({
            key: 'suggestions',
            value: []
        });
        let payload = {
            body: {
                data: [suggestion],
                limit:0,
                offset:0,
                totalRecords:1
            }
        };
        this.props.getBrokersSuccess(payload);
    };

    submitListFilters = (evt) => {
        evt.preventDefault()
    };

    _handleAutoSuggestIconClick = () => {
        let calcOffset =this.props.viewAmount*(this.props.page -1);
        this.props.getBrokers( {
            orderAsc: this.props.sortOrder === 'ASC',
            orderBySolicitorName:  this.props.sortBy ===  'name',
            orderByUserName:  this.props.sortBy ===  'username',
            orderByLawsysId:  this.props.sortBy ===  'brokerFirmId',
            orderByLawsysName:  this.props.sortBy ===  'brokerFirmName',
            lawsysId:  this.props.filterByBroker,
            limit: this.props.viewAmount,
            search:  this.props.suggestionFieldValue,
            offset: calcOffset>0? calcOffset:0,
        });
    };

    render(){
        const tableColumns = [
            {
                name: (
                    <CustomCheckbox
                        name={"selectedAllBrokers "}
                        checked={this.props.allBrokersSelected}
                        label=""
                        _onChange={this._handleAllRowsSelect}
                    />
                ),
                key: 'checkbox',
                sortable: false
            },
            {name: 'AgencyID', key: 'brokerFirmId', sortable: true},
            {name: 'Agency Name', key: 'brokerFirmName', sortable: true},
            {name: 'Name', key: 'name', sortable: true},
            {name: 'Username', key: 'username', sortable: true},
            {name: 'Status', key: 'status', sortable: false},
        ];
        const autoSuggestInputProps = {
            value: this.props.suggestionFieldValue,
            onChange: this.onSuggestionChange
        };

        return(
            <Brokers
                {...this.props}
                submitListFilters={this.submitListFilters}
                onSuggestionSelected={this.onSuggestionSelected}
                renderSuggestion={renderSuggestion}
                getSuggestionValue={getSuggestionValue}
                onSuggestionsClearRequested={this.onSuggestionsClearRequested}
                onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
                autoSuggestInputProps={autoSuggestInputProps}
                tableColumns={tableColumns}
                _isRowChecked={this._isRowChecked}
                _handleRowSelect={this._handleRowSelect}
                applyAction={this.applyAction}
                _handleAutoSuggestIconClick={this._handleAutoSuggestIconClick}
            />
        )
    }
}

const mapStateToProps = (state) => {
    return {
        brokers: state.brokers.brokers,
        suggestions: state.brokers.suggestions,
        loading: state.brokers.fetching,
        selectedBrokers: state.brokers.selectedBrokers,
        allBrokersSelected: state.brokers.allBrokersSelected,
        viewAmount: state.brokers.viewAmount,
        action: state.brokers.action,
        totalPaginationBoxes: state.brokers.totalPaginationBoxes,
        page: state.brokers.page,
        totalRecords: state.brokers.totalRecords,
        suggestionFieldValue: state.brokers.suggestionFieldValue,
        brokerFirms: state.brokerFirms.brokerFirms,
        filterByBroker: state.brokers.filterByBroker,
        sortBy: state.brokers.sortBy,
        sortOrder: state.brokers.sortOrder,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        getBrokers: (payload) => {
            dispatch(getBrokers(payload))
        },
        changeBrokersState: (payload) => {
            dispatch(changeBrokersState(payload))
        },
        brokersListPageShift: (payload) => {
            dispatch(brokersListPageShift(payload))
        },
        changeBrokersListPage: (payload) => {
            dispatch(changeBrokersListPage(payload))
        },
        getBrokersSuggestions: (payload) => {
            dispatch(getBrokersSuggestions(payload))
        },
        updateBrokerById: (payload) => {
            dispatch(updateBrokerById(payload))
        },
        getBrokerFirmsWithAgents: (payload) => {
            dispatch(getBrokerFirmsWithAgents(payload))
        },
        sortBrokers: (payload) => {
            dispatch(sortBrokers(payload))
        },
        getBrokersSuccess: (payload) => {
            dispatch(getBrokersSuccess(payload))
        }
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(BrokersHOC)